'use strict';

var TableContext$1 = require('../../../../_virtual/TableContext.js_commonjs-exports.js');
var interopRequireWildcard = require('../../../@babel/runtime/helpers/interopRequireWildcard.js');
var React$1 = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);

var _interopRequireWildcard = interopRequireWildcard;

Object.defineProperty(TableContext$1.__exports, "__esModule", {
  value: true
});
TableContext$1.__exports.default = void 0;

var React = _interopRequireWildcard(React__default["default"]);

/**
 * @ignore - internal component.
 */
var TableContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

var _default = TableContext;
TableContext$1.__exports.default = _default;
